import { APICallV3Post } from 'reactApp/api/APICall';

export class SubscriptionBuyAPICall extends APICallV3Post {
    _method = 'billing/subscription/buy';
}
